import React from 'react'

const EditDesignVariantStatus = ({
                                     designVariant,
                                     markAsPublished,
                                     markAsReadyToPublish,
                                     markAsInDesign,
                                     statusChangeInProgress
                                 }) => {
    return (
        <>
            {(!designVariant?.status || designVariant?.status === 'in-design') && markAsReadyToPublish &&
                <div className="flex justify-around">
                    <div className="flex justify-around">
                        {statusChangeInProgress &&
                            <button
                                disabled={statusChangeInProgress}
                                className="button-green-outline px-4 py-2 flex items-center justify-center w-56">
                                <div
                                    className={`w-6 h-6 border-b-2 border-t-2 border-green-600 rounded-full animate-spin`}></div>
                                <div className="ml-2">Saving In Progress...</div>
                            </button>
                        }

                        {!statusChangeInProgress &&
                            <button
                                className="button-green px-4 py-2 flex items-center justify-center w-56"
                                onClick={markAsReadyToPublish}>
                                <span>Mark As Ready To Publish</span>
                            </button>
                        }
                    </div>
                </div>
            }

            {designVariant?.status === 'ready-to-publish' &&
                <div className="flex justify-around">
                    {markAsPublished &&
                        <div className="flex justify-around">
                            {statusChangeInProgress &&
                                <button
                                    disabled={statusChangeInProgress}
                                    className="button-purple-outline px-4 py-2 flex items-center justify-center w-56">
                                    <div
                                        className={`w-6 h-6 border-b-2 border-t-2 border-purple-600 rounded-full animate-spin`}></div>
                                    <div className="ml-2">Saving In Progress...</div>
                                </button>
                            }

                            {!statusChangeInProgress &&
                                <button
                                    className="button-purple px-4 py-2 flex items-center justify-center w-56"
                                    onClick={markAsPublished}>
                                    <span>Mark As Published</span>
                                </button>
                            }
                        </div>
                    }

                    {markAsInDesign &&
                        <div className="flex justify-around">
                            {statusChangeInProgress &&
                                <button
                                    disabled={statusChangeInProgress}
                                    className="button-gray-outline px-4 py-2 flex items-center justify-center w-56">
                                    <div
                                        className={`w-6 h-6 border-b-2 border-t-2 border-gray-600 rounded-full animate-spin`}></div>
                                    <div className="ml-2">Saving In Progress...</div>
                                </button>
                            }

                            {!statusChangeInProgress &&
                                <button
                                    className="button-gray px-4 py-2 flex items-center justify-center w-56"
                                    onClick={markAsInDesign}>
                                    <span>Mark As In Design</span>
                                </button>
                            }
                        </div>
                    }
                </div>
            }

            {designVariant?.status === 'published' && markAsInDesign &&
                <div className="flex justify-around">
                    {statusChangeInProgress &&
                        <button
                            disabled={statusChangeInProgress}
                            className="button-gray-outline px-4 py-2 flex items-center justify-center w-56">
                            <div
                                className={`w-6 h-6 border-b-2 border-t-2 border-gray-600 rounded-full animate-spin`}></div>
                            <div className="ml-2">Saving In Progress...</div>
                        </button>
                    }

                    {!statusChangeInProgress &&
                        <button
                            className="button-gray px-4 py-2 flex items-center justify-center w-56"
                            onClick={markAsInDesign}>
                            <span>Mark As In Design</span>
                        </button>
                    }
                </div>
            }
        </>
    )
}

export default EditDesignVariantStatus
